export enum ListDevicesActionTypes {
  ON_CHANGE_INPUT = 'ON_CHANGE_INPUT',
  LIST_DEVICES_REQUEST = 'LIST_DEVICES_REQUEST',
  LIST_DEVICES_SUCCEEDED = 'LIST_DEVICES_SUCCEEDED',
  LIST_DEVICES_FAILED = 'LIST_DEVICES_FAILED',
  CLOSE_SEARCH_MODAL = 'CLOSE_SEARCH_MODAL',
}

type resultType = {
  total: number;
  devices: Array<object>;
};

export interface OnChangeInput {
  type: ListDevicesActionTypes.ON_CHANGE_INPUT;
  value: string;
}

export interface ListDevicesRequest {
  type: ListDevicesActionTypes.LIST_DEVICES_REQUEST;
  input: object;
}

export interface ListDevicesSucceeded {
  type: ListDevicesActionTypes.LIST_DEVICES_SUCCEEDED;
  result: resultType;
}

export interface ListDevicesFailed {
  type: ListDevicesActionTypes.LIST_DEVICES_FAILED;
  error: string;
}

export interface CloseSearchModal {
  type: ListDevicesActionTypes.CLOSE_SEARCH_MODAL;
}

export type ListDevicesActions =
  | OnChangeInput
  | ListDevicesRequest
  | ListDevicesSucceeded
  | ListDevicesFailed
  | CloseSearchModal;

export function onChangeInput(value: string): OnChangeInput {
  return {
    type: ListDevicesActionTypes.ON_CHANGE_INPUT,
    value,
  };
}

export function listDevicesRequest(input): ListDevicesRequest {
  return {
    type: ListDevicesActionTypes.LIST_DEVICES_REQUEST,
    input,
  };
}

export function listDevicesSucceeded(result: resultType): ListDevicesSucceeded {
  return {
    type: ListDevicesActionTypes.LIST_DEVICES_SUCCEEDED,
    result,
  };
}

export function listDevicesFailed(error: string): ListDevicesFailed {
  return {
    type: ListDevicesActionTypes.LIST_DEVICES_FAILED,
    error,
  };
}

export const closeSearchModal = () => ({
  type: ListDevicesActionTypes.CLOSE_SEARCH_MODAL,
});
